import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chart-tooltip',
  templateUrl: './chart-tooltip.component.html',
  styleUrl: './chart-tooltip.component.scss'
})
export class ChartTooltipComponent {
  @Input() title: string[] = [];
  @Input() legends: { label: string; value: number; color: string }[] = [];
  @Input() predictions: { label: string; value: number; color: string }[] = [];
  @Input() ips: { label: string; value: number; color: string }[] = [];
  @Input() position?: { left: number; top: number };
  @Input() visible: boolean = false;
}
